import Quiz from '@api/Quiz'
import {
    Button,
    Flex,
    Group,
    LoadingOverlay,
    Radio,
    Text,
    TextInput,
    Title,
} from '@mantine/core'
import { IconAt, IconPhone } from '@tabler/icons-react'
import InputTopicContact from '@components/inputs/quiz/InputTopicContact'

const FormSubmitPDF = ({
    quiz_id,
    pdf,
    formContact,
    person_type,
    close,
}: {
    quiz_id: number
    pdf: any
    formContact: any
    person_type: number
    close: any
}) => {
    const { onSubmit, isLoading } = Quiz.useSendMailPDF({
        form: formContact,
        aftersuccess: () => {
            close()
        },
    })

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault()
                formContact!.values.quiz_id = quiz_id
                formContact!.values.person_type = person_type
                formContact!.values.pdf = pdf
                onSubmit()
            }}
        >
            <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />

            <Flex
                mb='xl'
                direction={{ xs: 'column', sm: 'row' }}
                gap='lg'
                justify={{ xs: 'center', sm: 'space-between' }}
            >
                <Flex
                    style={{ width: '100%' }}
                    mb='xl'
                    direction={{ base: 'column' }}
                    gap='xs'
                    justify={{ xs: 'center', sm: 'space-between' }}
                    align={{ xs: 'center', sm: 'center' }}
                >
                    <Title
                        fz={{
                            xs: '1.1rem',
                            sm: '1.2rem',
                            md: '1.2rem',
                            lg: '1.2rem',
                        }}
                        c='blue.5'
                        order={1}
                        style={{ textAlign: 'center' }}
                    >
                        บริการให้คำแนะนำทางการเงินส่วนบุคคล
                    </Title>

                    <Title
                        fz={{
                            xs: '1.2rem',
                            sm: '1.2rem',
                            md: '1.2rem',
                            lg: '1.5rem',
                        }}
                        c='fuchasia.5'
                        order={2}
                        style={{ textAlign: 'center' }}
                    >
                        ฟรี! ไม่มีค่าใช้จ่าย
                    </Title>

                    <Title
                        fz={{
                            xs: '1.0rem',
                            sm: '1.1rem',
                            md: '1.1rem',
                            lg: '1.1rem',
                        }}
                        c='blue.5'
                        order={1}
                        style={{ textAlign: 'center' }}
                    >
                        โดยนักวางแผนการเงิน
                        <span style={{ display: 'inline-block' }}>
                            ส่วนบุคคลของบริษัทฯ
                        </span>
                    </Title>

                    <ul style={{ maxWidth: '350px', width: '100%' }}>
                        <li>คำแนะนำจากคลินิกแก้หนี้</li>
                        <li>วางแผนคุ้มครองของครอบครัว</li>
                        <li>วางแผนสำหรับเป้าหมายขนาดใหญ่ </li>
                        <li>วางแผนเกษียณและพอร์ตกองทุนสำรองเลี้ยงชีพ</li>
                        <li>วางแผนสำหรับการลงทุน</li>
                        <li>วางแผนมรดก</li>
                    </ul>
                    <Text fz={12} style={{ maxWidth: '500px' }}>
                        *คุณได้อ่านและทำความเข้าใจรายละเอียดของประกาศการคุ้มครองข้อมูลส่วนบุคคลของบริษัทฯ
                        ที่{' '}
                        <a
                            href='https://www.muangthai.co.th'
                            target='_blank'
                            rel='noreferrer'
                        >
                            www.muangthai.co.th
                        </a>{' '}
                        โดยคุณรับทราบว่าบริษัทฯ
                        จะเก็บรวบรวมข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์ในการให้บริการให้คำปรึกษาฯ
                        วิเคราะห์ข้อมูลทางการเงินเพื่อนำเสนอผลิตภัณฑ์ทางการเงินให้ตรงตามความต้องการของท่านตามคำร้องขอของท่าน
                        เท่านั้น
                    </Text>
                </Flex>

                <Flex
                    style={{ width: '100%' }}
                    direction={{ base: 'column' }}
                    gap='xs'
                    justify={{ xs: 'center', sm: 'space-between' }}
                >
                    <Text style={{ textAlign: 'center' }} mb='md'>
                        กรุณากรอกข้อมูลเพื่อ
                        <span style={{ display: 'inline-block' }}>
                            ให้ที่ปรึกษาทางการเงินติดต่อกลับ
                        </span>
                    </Text>
                    <InputTopicContact
                        styles={{
                            input: {
                                borderColor: 'var(--mantine-color-gray-2)',
                            },
                        }}
                        {...formContact!.getInputProps('topic')}
                    />
                    <Flex
                        style={{ width: '100%' }}
                        direction={{ base: 'column', sm: 'row' }}
                        gap='xs'
                        justify={{ xs: 'center', sm: 'space-between' }}
                    >
                        <TextInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formContact!.getInputProps('firstname')}
                            label='ชื่อ:'
                            placeholder=''
                            data-autofocus
                        />

                        <TextInput
                            styles={{
                                input: {
                                    borderColor: 'var(--mantine-color-gray-2)',
                                },
                            }}
                            {...formContact!.getInputProps('lastname')}
                            label='นามสกุล:'
                            placeholder=''
                            data-autofocus
                        />
                    </Flex>

                    <TextInput
                        styles={{
                            input: {
                                borderColor: 'var(--mantine-color-gray-2)',
                            },
                        }}
                        {...formContact!.getInputProps('mobileno')}
                        leftSection={<IconPhone size='15px' />}
                        label='เบอร์โทรศัพท์:'
                        placeholder='เบอร์โทรศัพท์ '
                        data-autofocus
                    />
                    <TextInput
                        styles={{
                            input: {
                                borderColor: 'var(--mantine-color-gray-2)',
                            },
                        }}
                        {...formContact!.getInputProps('email')}
                        leftSection={<IconAt size='15px' />}
                        label='อีเมล:'
                        placeholder='อีเมล '
                        data-autofocus
                    />

                    <Radio.Group
                        {...formContact!.getInputProps('disclosing')}
                        withAsterisk
                    >
                        <Group mt='xs'>
                            <Radio
                                value='true'
                                label='ปรึกษาแบบเปิดเผยข้อมูล'
                            />
                            <Radio
                                value='false'
                                label='ปรึกษาแบบไม่เปิดเผยข้อมูล'
                            />
                        </Group>
                    </Radio.Group>

                    <Button
                        fullWidth
                        type='submit'
                        radius='10px'
                        mt='md'
                        color='#e6007e'
                    >
                        นัดรับคําปรึกษา
                    </Button>
                </Flex>
            </Flex>
        </form>
    )
}

export default FormSubmitPDF
